/*
 * Marketplace specific configuration.
 */

import insuranceLogo from '../src/assets/insuranceLogo.svg';

export const country = 'fr';

export const mailContact = 'hello@swimmy.fr';

export const pressMail = 'presse@swimmy.fr';
export const pressPhoneNumber = null;
export const pressPhoneNumberReadable = '06 65 56 87 62';

export const supportPhoneNumber = '+33186476130';
export const supportPhoneNumberReadable = '01 86 47 61 30';

export const providersSupportPhoneNumber = '+33189318716';
export const providersSupportPhoneNumberReadable = '01 89 31 87 16';

export const teamBuildingMail = 'hello@swimmy.fr';
export const birthdayMail = 'hello@swimmy.fr';

export const supportHours = {
  start: '10:00',
  end: '18:00',
};

export const hasZendeskWidget = true;

export const hasBlog = true;
export const blogUrl = 'https://blog.swimmy.fr/';

export const hasInsurance = true;
export { insuranceLogo };

export const hasSecurityLaw = true;
export const securityRulesURL = 'https://www.swimmy.fr/security-rules';
export const securityOptions = [
  { key: 'barriereDeProtection', label: 'Barrière de protection' },
  { key: 'bacheDeSecurite', label: 'Bâche de sécurité' },
  { key: 'abriDePiscine', label: 'Abri de piscine' },
  { key: 'alarmeDeSecurite', label: 'Alarme de sécurité' },
];

// this is used to toggle reviews on LandingPage/SimulatorPage
export const showReviews = false;

export const showPressArticles = true;

export const stripeIdentityDocuments = [
  'Passeport',
  'Permis de conduire - recto ET verso',
  'Carte d\'identité - recto ET verso',
];
export const stripeAddressDocuments = [
  'Facture de téléphone - datée de moins de 6 mois',
  'Facture d\'électricité, de gaz ou d\'eau - datée de moins de 6 mois',
  'Attestation ou facture d\'assurance du logement - datée de moins de 6 mois',
  'Titre de propriété',
];

export const eventQuery =
  '?address=France&bounds=51.1241999%2C9.662499900000057%2C41.3253001%2C-5.559099999999944&country=FR';
// for ES use this one instead : ?address=Espagne&bounds=45.244%2C5.098%2C35.17300000000001%2C-12.524&origin=40.46366700000001%2C-3.74922&country=ES

export const amenities = [
  { key: 'piscine_interieure', label: '🏊 Piscine intérieure' },
  { key: 'piscine_chauffee', label: '🌡️ Piscine chauffée' },
  { key: 'piscine_exterieure', label: '🏊‍♂️ Piscine extérieure' },
  { key: 'douche', label: '🚿 Douche' },
  { key: 'toilette', label: '🚽 Toilette' },
  { key: 'jacuzzi', label: '🛁 Jacuzzi' },
  { key: 'sauna', label: '🧖 Sauna' },
  { key: 'jardin', label: '☀️ Jardin' },
  { key: 'transats', label: '⛱️ Transats' },
  { key: 'table_et_chaises', label: '🪑 Table et chaises' },
  { key: 'bbq', label: '🍖 Barbecue' },
  { key: 'bouées', label: '🤽 Bouées gonflables' },
  { key: 'jeux', label: '🥏 Jeux d\'extérieur' },
  { key: 'tennis', label: '🎾 Terrain de tennis' },
  { key: 'petanque', label: '🎯 Terrain de pétanque' },
  { key: 'wifi', label: '💻 Wi-Fi' },
];

export const validExtras = ['barbecueFee', 'towelsFee', 'jacuzziFee', 'snackFee'];

export const paidExtras = [
  {
    data: {
      amount: 1000,
      currency: 'EUR',
      id: 'barbecueFee',
      isByUnit: false,
      information:
        'Vous pouvez proposer votre barbecue pour 10€ par location. Vous vous engagez simplement à fournir le combustible.',
    },
    key: 'barbecueFee',
    label: '🍖 Barbecue • 10€',
  },
  {
    data: {
      amount: 300,
      currency: 'EUR',
      id: 'towelsFee',
      isByUnit: true,
      information: 'Vous pouvez proposer une serviette pour 3€/serviette.',
    },
    key: 'towelsFee',
    label: '🧺 Serviette • 3€/personne',
  },
  {
    data: { amount: 1000, currency: 'EUR', id: 'jacuzziFee', isByUnit: true },
    key: 'jacuzziFee',
    label: '🛁 Spa / Jacuzzi • 10€/personne',
  },
  {
    data: {
      amount: 400,
      currency: 'EUR',
      id: 'snackFee',
      isByUnit: true,
      information:
        'Vous pouvez proposer un goûter/collation pour 4€/personne. Vous pouvez ajouter la description dans votre annonce.',
    },
    key: 'snackFee',
    label: '🥤 Goûter • 4€/personne',
  },
];

export const providerPresentOptions = [
  { key: 'oui', label: 'Oui' },
  { key: 'non', label: 'Non' },
  { key: 'occasionnellement', label: 'Occasionnellement' },
];

export const getOverLookedEditListing = (intl) => [
  {
    label: intl.formatMessage({ id: 'EditListingForm.OverLookedNo' }),
    key: 'OverLookedNo',
  },
  {
    label: intl.formatMessage({ id: 'EditListingForm.OverLookedYesLight' }),
    key: 'OverLookedYesLight',
  },
  {
    label: intl.formatMessage({ id: 'EditListingForm.OverLookedYes' }),
    key: 'OverLookedYes',
  },
];

export const getDeclineReasons = (intl) => [
  {
    label: intl.formatMessage({ id: 'DeclineReason.BadWeatherCondition' }),
    key: 'badWeatherCondition',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.PoolNotAvailable' }),
    key: 'poolNotAvailable',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.Other' }),
    key: 'other',
  },
];

export const getDeclineByProviderReasons = (intl) => [
  {
    label: intl.formatMessage({ id: 'DeclineReason.TooLateRequest' }),
    key: 'tooLateRequest',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.OwnerPersonalUse' }),
    key: 'ownerPersonalUse',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.OwnerNotAvailable' }),
    key: 'ownerNotAvailable',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.LowBookingAmount' }),
    key: 'lowBookingAmount',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.MultipleRequests' }),
    key: 'multipleRequests',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.TenantAskedToCancel' }),
    key: 'tenantAskedToCancel',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.UntrustedProfile' }),
    key: 'untrustedProfile',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.Other' }),
    key: 'other',
  },
];

export const getCancelByProviderReasons = (intl) => [
  {
    label: intl.formatMessage({ id: 'DeclineReason.BadWeatherCondition' }),
    key: 'badWeatherCondition',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.NoAnswerFromCustomer' }),
    key: 'noAnswerFromCustomer',
  },

  {
    label: intl.formatMessage({ id: 'DeclineReason.OwnerPersonalUse' }),
    key: 'ownerPersonalUse',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.TenantAskedToCancel' }),
    key: 'customerAskedToCancel',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.UntrustedProfile' }),
    key: 'untrustedProfile',
  },
  {
    label: intl.formatMessage({ id: 'DeclineReason.Other' }),
    key: 'other',
  },
];

export const howDidYouKnowUsOptions = [
  { key: 'wordOfMouth', label: 'Bouche à oreilles' },
  { key: 'medias', label: 'Médias' },
  { key: 'bySwimmyTeamContact', label: 'J\'ai été contacté par l\'équipe Swimmy' },
  { key: 'byFacebook', label: 'Facebook' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'postcard', label: 'J\'ai reçu une carte postale' },
  { key: 'byAds', label: 'J\'ai vu une pub sur internet' },
  { key: 'bySwimmyBlog', label: 'Le Blog Swimmy' },
];

/**
 * Customer commission percentage which is added
 * to the total price of every booking.
 */
export const customerCommissionPercentage = 20;

/**
 * Discount multiplier for children.
 */
export const childrenDiscountMultiplier = 0.5;

/**
 * Custom multipliers to be used with bounds expansion
 * to run location searches on larger areas.
 *
 * The key musy match the address value of a place
 * returned by the Google Maps API.
 */
export const customBoundsMultiplier = {};

export const filters = [
  {
    id: 'price',
    label: 'Prix',
    type: 'PriceFilter',
    group: 'primary',
    // Note: PriceFilter is fixed filter,
    // you can't change "queryParamNames: ['price'],"
    queryParamNames: ['price'],
    // Price filter configuration
    // Note: unlike most prices this is not handled in subunits
    config: {
      min: 2,
      max: 100,
      step: 1,
    },
  },
  {
    id: 'superHost',
    label: 'Filter.superHostLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_isHostedBySuperHost'],
    config: {
      helper: 'Filter.superHostHelper',
    },
  },
  {
    id: 'suitableForChildren',
    label: 'Filter.suitableForChildrenLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_enfantsBienvenue'],
    config: {
      helper: 'Filter.suitableForChildrenHelper',
    },
  },
  {
    id: 'policyEvent',
    label: 'Filter.policyEventLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyEvent'],
    config: {
      helper: 'Filter.policyEventHelper',
    },
  },
  {
    id: 'policyMusic',
    label: 'Filter.policyMusicLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyMusic'],
    config: {
      helper: 'Filter.policyMusicHelper',
    },
  },
  {
    id: 'policyPets',
    label: 'Filter.policyPetsLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyPets'],
    config: {
      helper: 'Filter.policyPetsHelper',
    },
  },
  {
    id: 'policyAlcohol',
    label: 'Filter.policyAlcoholLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyAlcohol'],
    config: {
      helper: 'Filter.policyAlcoholHelper',
    },
  },
  {
    id: 'policySmoking',
    label: 'Filter.policySmokingLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policySmoking'],
    config: {
      helper: 'Filter.policySmokingHelper',
    },
  },
  {
    id: 'burkiniAllowed',
    label: 'Filter.burkiniLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_burkiniAllowed'],
    config: {
      helper: 'Filter.burkiniHelper',
    },
  },
  {
    id: 'naturistAllowed',
    label: 'Filter.naturismLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_naturistAllowed'],
    config: {
      helper: 'Filter.naturismHelper',
    },
  },
  {
    id: 'amenities',
    label: 'Équipements',
    type: 'SelectMultipleFilter',
    group: 'secondary',
    queryParamNames: ['pub_extras'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_all',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      options: amenities,
    },
  },
];

export const sortConfig = {
  // Enable/disable the sorting control in the SearchPage
  active: false,

  // Note: queryParamName 'sort' is fixed,
  // you can't change it since Flex API expects it to be named as 'sort'
  queryParamName: 'sort',

  // Internal key for the relevance option, see notes below.
  relevanceKey: 'relevance',

  // Keyword filter is sorting the results already by relevance.
  // If keyword filter is active, we need to disable sorting.
  conflictingFilters: ['keyword'],

  options: [
    { key: 'createdAt', label: 'Newest' },
    { key: '-createdAt', label: 'Oldest' },
    { key: '-price', label: 'Lowest price' },
    { key: 'price', label: 'Highest price' },

    // The relevance is only used for keyword search, but the
    // parameter isn't sent to the Marketplace API. The key is purely
    // for handling the internal state of the sorting dropdown.
    { key: 'relevance', label: 'Relevance', longLabel: 'Relevance (Keyword search)' },
  ],
};

// 'km' for kilometers or 'mi' for miles
export const distanceUnit = 'km';

/**
 * If isSeasonalMarketplace is true both seasonStart and
 * seasonEnd must have a value
 *
 * Months have to be set using those values :
 * January = 0
 * ...
 * December = 11
 */
export const isSeasonalMarketplace = true;
export const seasonStart = {
  month: 'Mars',
  value: 2,
};
export const seasonEnd = {
  month: 'Septembre',
  value: 8,
};

// By default the age requirement is 18
export const marketplaceAgeRequirement = 18;

export const minStartHourToBook = 9;

// key is for average cost in the labeled region
export const simulatorFormLocations = [
  { key: 2500, label: `Provence-Alpes-Côte d'Azur` },
  { key: 3800, label: 'Île-de-France' },
  { key: 2200, label: 'Auvergne-Rhône-Alpes' },
  { key: 2800, label: 'Occitanie' },
  { key: 2500, label: 'Grand Est' },
  { key: 3000, label: 'Nouvelle-Aquitaine' },
  { key: 2600, label: 'Normandie' },
  { key: 2800, label: 'Hauts-de-France' },
  { key: 2100, label: 'Centre-Val de Loire' },
  { key: 2200, label: 'Bourgogne-Franche-Comté' },
  { key: 2000, label: 'Pays de la Loire' },
  { key: 1900, label: 'Bretagne	' },
  { key: 2200, label: 'Autres régions' },
];

export const withEveningBookingModeDate = '2021-04-13T15:30:00.000Z';

export const insuranceSlug = 'roots?slug=insurance-fr';

export const termsOfUseSlug = 'roots?slug=terms-of-use-fr';

export const helpCenterUrl = 'https://help.swimmy.com/hc/fr';
export const helpCenterUrlForCustomers =
  'https://help.swimmy.com/hc/fr/categories/360002484820-Je-suis-locataire';
export const helpCenterUrlForProviders =
  'https://help.swimmy.com/hc/fr/categories/360002499219-Je-suis-propri%C3%A9taire';

export const legalNoticeSlug = 'roots?slug=legal-notice-fr';

export const appStoreLink =
  'https://apps.apple.com/fr/app/swimmy-location-de-piscines/id1553975232';
export const playStoreLink =
  'http://play.google.com/store/apps/details?id=com.swimmy.swimmy&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
export const openTicketLink =
  'https://help.swimmy.com/hc/fr/requests/new';

export const MIN_TOTAL_FOR_PROPOSAL = 50000;
